module.exports = __webpack_public_path__ + "img/DatabaseDisconnected.94a81164.svg";